import React, { Fragment } from "react";
import { Outlet } from "react-router-dom";
//import SideBar from "./dashboard/sidebar/sidebar";
import Header from "./dashboard/header";
import Footer from "./dashboard/footer";
import Switcher from "./dashboard/switcher/switcher";
import "../index.scss";
import SideBar from "./dashboard/sidebar/sidebar";
import PrivateRoute from "./dashboard/privateroute";
import BackupScheduler from "./dashboard/backup/BackupScheduler";
import AdminSideBar from "./admin/sidebar/sidebar";
import TeacherSideBar from "./teacher/sidebar/sidebar";
import StudentSideBar from "./student/sidebar/sidebar";
import WorkerSideBar from "./worker/sidebar/sidebar";
import AccountSidebar from "./accounts/sidebar";
import WardenSidebar from "./warden/sidebar";
import DriverSidebar from "./driver/sidebar";
import FrontdeskSidebar from "./frontdesk/sidebar";
const App = () => {
  document.querySelector("body").classList.remove("error-1");
  document
    .querySelector("body")
    .classList.remove("app", "sidebar-mini", "landing-page", "horizontalmenu");
  document.querySelector("body").classList.add("main-body", "leftmenu");
  const remove = () => {
    // document.querySelector(".sidebar-right").classList.remove("sidebar-open");
    document.querySelector("body").classList.remove("main-sidebar-show");
    document.querySelector(".demo_changer").classList.remove("active");
    document.querySelector(".demo_changer").style.right = "-270px";
  };

  return (
    <Fragment>
      <div className="horizontalMenucontainer">
        <BackupScheduler />
        <Switcher />
        <div className="page">
          <Header />
          {localStorage.getItem("Role") === "1" && <SideBar />}
          {localStorage.getItem("Role") === "2" && <AdminSideBar />}
          {localStorage.getItem("Role") === "4" && <StudentSideBar />}
          {localStorage.getItem("Role") === "5" && <TeacherSideBar />}
          {localStorage.getItem("Role") === "6" && <WorkerSideBar />}
          {localStorage.getItem("Role") === "7" && <AccountSidebar />}
          {localStorage.getItem("Role") === "8" && <WardenSidebar />}
          {localStorage.getItem("Role") === "9" && <DriverSidebar />}
          {localStorage.getItem("Role") === "10" && <FrontdeskSidebar />}

          <PrivateRoute />
          <div className="main-content side-content">
            <div
              className="main-container container-fluid"
              onClick={() => remove()}
            >
              <div className="inner-body">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </Fragment>
  );
};
export default App;
